module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921095651_T.ffc3a32a.jpg";